export const libraryManagementFeatureKey = 'libraryManagement';
